import { combineReducers, Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { appReducer, AppState } from './app';
import { ModalState, modalReducer } from './modal';

export interface RootState {
  router: any;
  appData: AppState;
  modalData: ModalState;
}

const createRootReducer = (history: any) => combineReducers({
  router: connectRouter(history),
  appData: appReducer,
  modalData: modalReducer,
}) as Reducer<RootState>;

export default createRootReducer;
